import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../environments/environment";
import { Settings, Preferences } from "../models/settings";
import { SettingsService } from "../services/settings.service";
import {InformationService} from "../services/information.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent {

  settings: Settings = {
    src: "",
    restURL: "",
    tokenURL: "",
    redirectURL: "",
    domains: [],
    preferences: { defaultLanguage: 'en', progressBarVisibile: true, overrides: {} }
  }
  domain: string;
  urlDomain: string;
  redirectURL: string;
  preferences: Preferences;
  loading = true;

  constructor(
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private informationService: InformationService
  ) {
    this.domain = this.route.snapshot.queryParamMap.get("domain");
    this.urlDomain = this.route.snapshot.queryParamMap.get("domain");
  }

  ngOnInit() {

    let nibbles = this.route.snapshot.queryParamMap.get("token");
    let domain = this.route.snapshot.queryParamMap.get("domain");

    this.settingsService.getSettings().subscribe((response) => {
      this.settings = response;
      environment.tokenDecriptionEndpoint = this.settings.tokenURL;

      if (this.settings.domains.indexOf(this.urlDomain) !== -1) {
        this.domain = this.urlDomain;
      } else {
        this.domain = "INFOCERT";
      }

      this.informationService.setVariable(this.domain, this.settings.preferences.overrides);

      environment.preferences = this.settings.preferences;

      this.preferences = this.settingsService.getPreferences(this.urlDomain);

      this.translateService.addLangs(['en', 'it', 'es']);
      this.translateService.setDefaultLang(this.preferences.defaultLanguage);

      let language = this.preferences.language || this.preferences.defaultLanguage|| this.translateService.getBrowserLang();
      if (this.translateService.getLangs().indexOf(language) >= 0) {
        this.translateService.use(language);
      } else {
        const langSplitted = language.split('-');
        if (this.translateService.getLangs().indexOf(langSplitted[0]) >= 0) {
          this.translateService.use(langSplitted[0]);
        }
      }
      this.loading = false;

      this.settingsService.getRedirectURL(nibbles, domain).subscribe(response => {
        this.redirectURL = response.ref
        this.settings.redirectURL = this.redirectURL
      })
    })
  }
}
